import React, { useEffect, useState } from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import Notification from './components/Toast/notification';
import ConfirmDialog from './components/Modal/confirmDialog';
import DeviceDetector from './components/DeviceDetector/detector';
import 'rtc-device-detector-react/dist/index.css';
import './styles/globals.scss';
import a18n from 'a18n';
import Cookies from 'js-cookie';
import { getLanguage } from './utils/common';
import { getUrlParam } from './utils/utils';
import ContentLayout from './layout';

const theme = createTheme({
  palette: {
    primary: {
      main: '#006eff',
    },
  },
});

a18n.addLocaleResource('en', require('./locales/en.json'));
a18n.addLocaleResource('zh-CN', require('./locales/zh-CN.json'));
a18n.addLocaleResource('ja', require('./locales/ja.json'));

const audience = 'audience';
const anchor = 'anchor';
function App() {
  const [language, setLanguage] = useState('');
  const [isASRPath, setIsASRPath] = useState(false);
  const [isBrowser, setIsBrowser] = useState(true);
  const [userRole, setUserRole] = useState(audience);

  const changeLanguage = (language: string) => {
    a18n.setLocale(language);
    Cookies.set('trtc-api-example-lang', language);
    setLanguage(language);
  };

  useEffect(() => {
    if (navigator.userAgent.toLowerCase().includes('miniprogram')) {
      setIsBrowser(false);
    }
    const language = 'ja' || getLanguage();
    a18n.setLocale(language);
    Cookies.set('trtc-api-example-lang', language);
    setLanguage(language);
    setIsASRPath(location.href.includes('improve-asr'));

    const roleCurrent = getUrlParam('role');
    roleCurrent ? setUserRole(roleCurrent) : '';
  }, []);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <ContentLayout></ContentLayout>
      </ThemeProvider>
      <Notification></Notification>
      {/*<ConfirmDialog></ConfirmDialog>*/}
     {/* {userRole === anchor && <DeviceDetector language={language}></DeviceDetector>}*/}
    </div>
  );
}

export default App;
